const path = require('path');
const fs = require('fs');

module.exports = (function accessStream() {
  const accessLogPath = path.join(__dirname, `../logs/access.log`);
  fs.appendFileSync(accessLogPath, '');
  let accessWriteStream = fs.createWriteStream(accessLogPath, { flags: 'a' });
  const errCallback = () => {
    if (accessWriteStream) {
      accessWriteStream.end();
    }
    accessWriteStream = fs.createWriteStream(accessLogPath, { flags: 'a' });
    accessWriteStream.on('error', errCallback);
  };
  accessWriteStream.on('error', errCallback);
  return {
    getFileStream: () => accessWriteStream,
    resetFileStream: () => {
      if (accessWriteStream) {
        accessWriteStream.end();
      }
      try {
        accessWriteStream = fs.createWriteStream(accessLogPath, { flags: 'a' });
        accessWriteStream.on('error', errCallback);
      } catch (err) {
        console.log('resetFileStream err ====> ', err);
      }
    }
  };
})();
